import { getPageUiStates } from 'shared/lib/api';
import { SideModal, SideModalBody } from 'shared/ui/SideModal';
import { PageError } from 'shared/ui/PageError';
import { InfoBox } from 'shared/ui/InfoBox';
import type { HistoryFetcher, HistoryTableColumns } from 'entities/history';

import { HistoryTable } from './HistoryTable';

interface HistoryModalProps {
  useGetHistory: HistoryFetcher;
  historyTableColumns: HistoryTableColumns;
  title: string;
  autoTestAttributesName?: string;
  showArrowBack?: boolean;
}

export function HistoryModal({
  useGetHistory,
  historyTableColumns,
  title,
  autoTestAttributesName,
  showArrowBack,
}: HistoryModalProps) {
  const getHistoryQuery = useGetHistory();
  const historyData = getHistoryQuery.data?.data;
  const isEmptyHistoryData = historyData?.length === 0;
  const { hasErrors, isTableLoading } = getPageUiStates([getHistoryQuery]);

  const getTableView = () => {
    if (isEmptyHistoryData) {
      return (
        <InfoBox
          title="⏳ There are no history records at the moment"
          text="All tracked changes will be displayed in this section."
        />
      );
    }
    if (hasErrors) {
      return <PageError />;
    }

    return (
      <HistoryTable
        history={historyData}
        isLoading={isTableLoading}
        columns={historyTableColumns}
      />
    );
  };

  return (
    <SideModal
      autoTestAttributesName={autoTestAttributesName}
      isLarge
    >
      <SideModalBody
        title={title}
        showArrowBack={showArrowBack}
        isLarge
      >
        {getTableView()}
      </SideModalBody>
    </SideModal>
  );
}
